import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const UnauthorizedMainNavigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const userMenuRef = useRef(null);
  const navigate = useNavigate();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  }

  // useEffect(() => {
  //     const handleClickOutside = (event) => {
  //       if (userMenuRef?.current && !userMenuRef?.current?.contains(event?.target)) {
  //         setIsMobileMenuOpen(false);
  //       }
  //       if (mobileMenuRef?.current && !mobileMenuRef?.current?.contains(event?.target)) {
  //         setIsMobileMenuOpen(false);
  //       }
  //     };
  
  //     document.addEventListener('mousedown', handleClickOutside);
  //     return () => document.removeEventListener('mousedown', handleClickOutside);
  //   }, []);

  return (
    <nav className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center">
            <Link to="/" className="text-xl font-semibold text-indigo-600">JustBooked</Link>
          </div>

          <div className="hidden md:flex md:space-x-6">
            <Link to="/" className="text-gray-700 hover:text-indigo-600 px-3 py-2 rounded-md text-sm font-medium">Home</Link>
            <Link to="/subscription-plans" className="text-gray-700 hover:text-indigo-600 px-3 py-2 rounded-md text-sm font-medium">Subscription Plans</Link>
            <Link to="/contact-us" className="text-gray-700 hover:text-indigo-600 px-3 py-2 rounded-md text-sm font-medium">Contact Us</Link>
          </div>

          <div className="flex items-center">
            <Link to="/sign-up" className="ml-4 hidden md:inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-full text-indigo-600  border-indigo-600 hover:border-indigo-700 hover:text-indigo-700">Sign Up</Link>
            <Link to="/login" className="ml-4 hidden md:inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-full text-white bg-indigo-600 hover:bg-indigo-700">Login</Link>

            <div ref={userMenuRef} >
              <button ref={userMenuRef} className="md:hidden ml-3 p-2 rounded-md text-gray-500 hover:text-gray-700 focus:outline-none" aria-label="Open menu" onClick={toggleMobileMenu}>
                {!isMobileMenuOpen? (
                  <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                  </svg>):
                  (
                  <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                  </svg>
              )}

              </button>

            </div>
            
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden flex flex-col items-center absolute px-2 shadow pb-4 z-40 rounded-b-md bg-white w-full space-y-1 transform origin-top transition-all duration-200 ease-in-out ${isMobileMenuOpen ? 'scale-y-100 opacity-100' : 'scale-y-0 opacity-0 pointer-events-none'}`}
        aria-hidden={!isMobileMenuOpen}
        
      >
        <div className="block text-gray-700 hover:text-indigo-600 px-3 py-2 rounded-md text-base font-medium" onClick={() => handleNavigation('/')}>Home</div>
        <div className="block text-gray-700 hover:text-indigo-600 px-3 py-2 rounded-md text-base font-medium" onClick={() => handleNavigation('/subscription-plans')}>Subscription Plans</div>
        <div className="block text-gray-700 hover:text-indigo-600 px-3 py-2 rounded-md text-base font-medium" onClick={() => handleNavigation('/contact-us')}>Contact Us</div>
        <div className="block w-full text-center mt-2 px-4 py-2 border border-transparent text-sm font-medium rounded-full text-indigo-600  border-indigo-600 hover:border-indigo-700 hover:text-indigo-700" onClick={() => handleNavigation('/sign-up')}>Sign Up</div>
        <div className="block w-full text-center mt-2 px-4 py-2 border border-transparent text-sm font-medium rounded-full text-white bg-indigo-600 hover:bg-indigo-700" onClick={() => handleNavigation('/login')}>Login</div>
      </div>
    </nav>
  );
};

export default UnauthorizedMainNavigation;